import {
    initStartPasskeyIfSupportedFn,
    StartPasskeyIfSupportedFn,
} from './lib/methods/start-passkey-if-supported';
import {
    CreateIdentityIfEmailEligibleFn,
    initCreateIdentityIfEmailEligibleFn,
} from './lib/methods/create-identity-if-email-eligible';
import {
    ClaimTrialForRadioIdFn,
    initClaimTrialForRadioIdFn,
} from './lib/methods/claim-trial-for-radio-id';
import {
    ClaimTrialForVinFn,
    initClaimTrialForVinFn,
} from './lib/methods/claim-trial-for-vin';
import {
    CheckIdentityEligibilityAndVehicleStatusByRadioIdFn,
    initCheckIdentityEligibilityAndVehicleStatusByRadioIdFn,
} from './lib/methods/check-identity-eligibility-and-automotive-status-for-radio-id';
import {
    CheckIdentityEligibilityAndVehicleStatusByVinFn,
    initCheckIdentityEligibilityAndVehicleStatusByVinFn,
} from './lib/methods/check-identity-eligibility-and-automotive-status-for-vin';
import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import {
    ActivateUserCodeFn,
    initActivateUserCodeFn,
} from './lib/methods/activate-user-code';
import {
    CreateIdentityAndActivateUserCodeFn,
    initCreateIdentityAndActivateUserCodeFn,
} from './lib/methods/create-identity-and-activate-user-code';
import {
    CreateSalIdentityFn,
    initCreateSalIdentityFn,
} from './lib/methods/create-sal-identity';
import {
    ConvertDtokToMagicLinkFn,
    initConvertDtokToMagicLinkFn,
} from './lib/methods/convert-dtok-to-magic-link';
import {
    CheckSalStatusFn,
    initCheckSalStatusFn,
} from './lib/methods/check-sal-status';
import {
    initRedeemMagicLinkSalFn,
    RedeemMagicLinkSalFn,
} from './lib/methods/redeem-magic-link-sal';
import {
    CheckIdentityEligibilityForAutomotiveSubscriptionFn,
    initCheckIdentityEligibilityForAutomotiveSubscriptionFn,
} from './lib/methods/check-identity-eligibility-for-automotive-subscription';
import {
    CreateIdentityOrLoginFn,
    initCreateIdentityOrLoginFn,
} from './lib/methods/create-identity-or-login';
import {
    AcceptAgreementsForIdentityCreateFn,
    initAcceptAgreementsForIdentityCreateFn,
} from './lib/methods/accept-agreements-for-identity-create';
import {
    AcceptMarketingAgreementForDeviceLinkingFn,
    initAcceptMarketingAgreementForDeviceLinkingFn,
} from './lib/methods/accept-marketing-agreement-for-device-linking';

export interface DomainOnboarding {
    acceptAgreementsForIdentityCreate: AcceptAgreementsForIdentityCreateFn;
    acceptMarketingAgreementForDeviceLinking: AcceptMarketingAgreementForDeviceLinkingFn;
    checkIdentityEligibilityAndVehicleStatusByRadioId: CheckIdentityEligibilityAndVehicleStatusByRadioIdFn;
    checkIdentityEligibilityAndVehicleStatusByVin: CheckIdentityEligibilityAndVehicleStatusByVinFn;
    checkIdentityEligibilityForAutomotiveSubscription: CheckIdentityEligibilityForAutomotiveSubscriptionFn;
    claimTrialForRadioId: ClaimTrialForRadioIdFn;
    claimTrialForVin: ClaimTrialForVinFn;
    createIdentityOrLogin: CreateIdentityOrLoginFn;
    createIdentityIfEmailEligible: CreateIdentityIfEmailEligibleFn;
    startPasskeyIfSupported: StartPasskeyIfSupportedFn;
    activateUserCode: ActivateUserCodeFn;
    createIdentityAndActivateUserCode: CreateIdentityAndActivateUserCodeFn;
    createSalIdentity: CreateSalIdentityFn;
    convertDtokToMagicLink: ConvertDtokToMagicLinkFn;
    checkSalStatus: CheckSalStatusFn;
    redeemMagicLinkSal: RedeemMagicLinkSalFn;
}

export function domainOnboarding(
    domainInitPayload: DomainInitPayload,
): DomainOnboarding {
    return {
        acceptAgreementsForIdentityCreate:
            initAcceptAgreementsForIdentityCreateFn(domainInitPayload),
        acceptMarketingAgreementForDeviceLinking:
            initAcceptMarketingAgreementForDeviceLinkingFn(domainInitPayload),
        checkIdentityEligibilityAndVehicleStatusByRadioId:
            initCheckIdentityEligibilityAndVehicleStatusByRadioIdFn(
                domainInitPayload,
            ),
        checkIdentityEligibilityAndVehicleStatusByVin:
            initCheckIdentityEligibilityAndVehicleStatusByVinFn(
                domainInitPayload,
            ),
        checkIdentityEligibilityForAutomotiveSubscription:
            initCheckIdentityEligibilityForAutomotiveSubscriptionFn(
                domainInitPayload,
            ),
        claimTrialForRadioId: initClaimTrialForRadioIdFn(domainInitPayload),
        claimTrialForVin: initClaimTrialForVinFn(domainInitPayload),
        createIdentityOrLogin: initCreateIdentityOrLoginFn(domainInitPayload),
        createIdentityIfEmailEligible:
            initCreateIdentityIfEmailEligibleFn(domainInitPayload),
        startPasskeyIfSupported:
            initStartPasskeyIfSupportedFn(domainInitPayload),
        activateUserCode: initActivateUserCodeFn(domainInitPayload),
        createIdentityAndActivateUserCode:
            initCreateIdentityAndActivateUserCodeFn(domainInitPayload),
        createSalIdentity: initCreateSalIdentityFn(domainInitPayload),
        convertDtokToMagicLink: initConvertDtokToMagicLinkFn(domainInitPayload),
        checkSalStatus: initCheckSalStatusFn(domainInitPayload),
        redeemMagicLinkSal: initRedeemMagicLinkSalFn(domainInitPayload),
    };
}
